module.exports = __webpack_public_path__ + "static/media/menu-home.f11dd491.svg";